module.exports = __webpack_public_path__ + "fonts/500-italic-greek-ext.2c2d9a4.woff2";